import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Routes } from "../../constants/RouteConstants";
import authContext from "../../context/authContext";
import { USER_ROLE_TYPES } from "../../constants/Constants";
import toast, { Toast } from "react-hot-toast";

interface UpgradeToastProps {
    message?: string;
    t?: Toast;
}

const UpgradeToast: React.FC<UpgradeToastProps> = ({
    message = "Please upgrade your plan to use this feature.",
    t,
}) => {
    const navigate = useNavigate();
    const { data } = useContext(authContext);

    const isAdmin = data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN;
    const isInvitee = data?.is_invitee;

    const location = useLocation();
    const toastId = t?.id || "upgrade-toast";

    useEffect(() => {
        if (!isAdmin || isInvitee) {
            toast.error("This Household do not have the Active Subscription.", { id: "upgrade-error" });
            toast.dismiss(toastId);
        }
    }, [isAdmin, isInvitee, toastId]);

    // Dismiss toast on navigation or unmount
    useEffect(() => {
        return () => {
            toast.dismiss(toastId);
        };
    }, [location.pathname, toastId]);

    // If user is invitee or not admin, return null as we've shown an error toast instead
    if (!isAdmin || isInvitee) {
        return null;
    }

    const handleUpgradeClick = () => {
        toast.dismiss(toastId);
        navigate(Routes?.Subscription);
    };

    const isVisible = t ? t.visible : true;

    return (
        <div className={`upgrade-toast ${isVisible ? 'animate-enter' : 'animate-leave'}`}>
            <span className="upgrade-toast__text">{message}</span>
            <button
                className="upgrade-toast__button"
                onClick={handleUpgradeClick}
            >
                Upgrade
            </button>
        </div>
    );
};

export default UpgradeToast;